<template>
  <div class="webform w-100 spareparts_checkoutsteps" :class="['spareparts_checkoutsteps--'+theme, 'text-primary-'+theme, 'webform--'+theme]">
    <div :class="[theme == 'dark' ? 'bg-third-dark' : 'bg-fifth-white',activeStep == 'first' ? 'open' : '']" class="px-3 py-3 px-sm-4 py-sm-5 spareparts_checkoutsteps__one">
      <div @click="activeStep = 'first'" class="spareparts_checkoutsteps__top d-flex align-items-start pb-2 pb-sm-0 align-items-sm-center justify-content-between">
        <div class="d-flex flex-column flex-sm-row"><p class="d-flex align-items-center justify-content-center mr-4">1</p><span class="d-flex align-items-center">{{t('checkout.delivery_address')}}</span></div><a v-if="activeStep != 'first' && step1finish == true" @click="activeStep='first'" class="changeStep d-flex align-items-center justify-content-center">{{t('checkout.change')}}</a>
      </div>
      <div class="pt-1 pb-2 pr-0 pr-lg-3 spareparts_checkoutsteps__inside">
        <div v-show="activeStep == 'first'" class="spareparts_checkoutsteps__inside__change">
          <form enctype="multipart/form-data" method="post" novalidate="novalidate" class="form pb-4 form--floating-labels"><input type="hidden" name="path" value="checkout">
            <input type="hidden" name="id" value="623479722c086">
            <div class="form-item radio pb-2">
              <div class="pt-5 d-flex">
                <div class="form-item__selection">
                  <input @change="validateSpecificAddress(shippingAddress, errorShippingAddress, 'salutation')" v-model="shippingAddress.salutation" type="radio" id="62388fb3a052d" name="" :value="t('checkout.man')">
                  <label for="62388fb3a052d"> {{t('checkout.man')}} </label>
                </div>
                <div class="form-item__selection">
                  <input @change="validateSpecificAddress(shippingAddress, errorShippingAddress, 'salutation')" v-model="shippingAddress.salutation" type="radio" id="62388fb3a052f" name="" :value="t('checkout.woman')">
                  <label for="62388fb3a052f"> {{t('checkout.woman')}} </label>
                </div>
              </div>
              <span v-show="errorShippingAddress.salutation" data-v="" class="w-100 w-sm-50 w-lg-25 mandatorymessage">{{t('checkout.choose_salutation')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorShippingAddress.firstname ? 'error' : '']">
              <input @change="validateSpecificAddress(shippingAddress, errorShippingAddress, 'firstname')" v-model="shippingAddress.firstname" data-v=""  type="text" name="" :placeholder="t('checkout.firstname')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.firstname')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorShippingAddress.firstname" data-v="" class="mandatorymessage">{{t('checkout.choose_firstname')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorShippingAddress.lastname ? 'error' : '']">
              <input @change="validateSpecificAddress(shippingAddress, errorShippingAddress, 'lastname')" v-model="shippingAddress.lastname" data-v=""  type="text" name="" :placeholder="t('checkout.lastname')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.lastname')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorShippingAddress.lastname" data-v="" class="mandatorymessage">{{t('checkout.choose_lastname')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorShippingAddress.company ? 'error' : '']">
              <input v-model="shippingAddress.company" data-v=""  type="text" name="" :placeholder="t('checkout.company')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.company')}}</span>
              </label>
              <span data-v="" class="mandatorymessage" style="display: none;"></span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorShippingAddress.department ? 'error' : '']">
              <input v-model="shippingAddress.department" data-v=""  type="text" name="" :placeholder="t('checkout.department')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.department')}}</span>
              </label>
              <span data-v="" class="mandatorymessage" style="display: none;"></span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorShippingAddress.street ? 'error' : '']">
              <input @change="validateSpecificAddress(shippingAddress, errorShippingAddress, 'street')" v-model="shippingAddress.street" data-v=""  type="text" name="" :placeholder="t('checkout.street')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.street')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorShippingAddress.street" data-v="" class="mandatorymessage">{{t('checkout.choose_street')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorShippingAddress.street_addition ? 'error' : '']">
              <input @change="validateSpecificAddress(shippingAddress, errorShippingAddress, 'street_addition')" v-model="shippingAddress.street_addition" data-v=""  type="text" name="" :placeholder="t('checkout.number')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.number')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorShippingAddress.street_addition" data-v="" class="mandatorymessage">{{t('checkout.choose_streetnr')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorShippingAddress.zip ? 'error' : '']">
              <input @change="validateSpecificAddress(shippingAddress, errorShippingAddress, 'zip')" v-model="shippingAddress.zip" data-v=""  type="text" name="" :placeholder="t('checkout.zip')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.zip')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorShippingAddress.zip" data-v="" class="mandatorymessage">{{t('checkout.choose_zip')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorShippingAddress.city ? 'error' : '']">
              <input @change="validateSpecificAddress(shippingAddress, errorShippingAddress, 'city')" v-model="shippingAddress.city" data-v=""  type="text" name="" :placeholder="t('checkout.city')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.city')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorShippingAddress.city" data-v="" class="mandatorymessage">{{t('checkout.choose_city')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50 dropdown position-relative" :class="[errorShippingAddress.country ? 'error' : '']">
              <div :class="shippingAddress.country !== '' ? 'dropdown__selected--selected' : ''" class="dropdown__selected d-flex justify-content-end align-items-center">
                <label>
                  <span class="origin">{{countries[shippingAddress.country]}} <span class="mandatory">*</span></span>
                </label>
              </div>
              <span v-show="errorShippingAddress.country" data-v="" class="mandatorymessage">{{t('checkout.choose_country')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50">
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorShippingAddress.email ? 'error' : '']">
              <input @change="validateSpecificAddress(shippingAddress, errorShippingAddress, 'email')" v-model="shippingAddress.email" data-v=""  type="email" name="" :placeholder="t('checkout.email')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.email')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorShippingAddress.email" data-v="" class="mandatorymessage">{{t('checkout.choose_email')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorShippingAddress.phone ? 'error' : '']">
              <input @change="validateSpecificAddress(shippingAddress, errorShippingAddress, 'phone')" v-model="shippingAddress.phone" data-v=""  type="text" name="" :placeholder="t('checkout.phone')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.phone')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorShippingAddress.phone" data-v="" class="mandatorymessage">{{t('checkout.choose_phone')}}</span>
            </div>
          </form>
          <div :class="[diffrentaddress == true ? '' : 'active']" class="d-flex billadresscheckmark d-flex align-items-center">
            <div @click="diffrentaddress = !diffrentaddress" class="checkmarkcontainer d-flex justify-content-center align-items-center">
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   width="10px" height="10px" viewBox="0 0 78.369 78.369" style="enable-background:new 0 0 78.369 78.369;"
                   xml:space="preserve">
                        <g>
                            <path d="M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704
                                c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704
                                C78.477,17.894,78.477,18.586,78.049,19.015z"/>
                        </g>
                    </svg>
            </div>
            <p class="pl-2" :class="'text-primary-'+theme">{{t('checkout.is_same_address')}}</p>
          </div>
          <form :class="[diffrentaddress == true ? 'open' : '']" enctype="multipart/form-data" method="post" novalidate="novalidate" class="form pb-4 pt-5 form--floating-labels billingaddress">
            <div class="spareparts_checkoutsteps__top d-flex align-items-center">
              <span class="pt-3">{{t('checkout.billing_address')}}</span>
            </div>
            <input type="hidden" name="id2" value="623479722c086">
            <div class="form-item radio pb-2">
              <div class="d-flex pt-5">
                <div class="form-item__selection">
                  <input @change="validateSpecificAddress(billingAddress, errorBillingAddress, 'salutation')" v-model="billingAddress.salutation" type="radio" id="62388fb3a552d" name="" :value="t('checkout.man')">
                  <label for="62388fb3a552d"> {{t('checkout.man')}} </label>
                </div>
                <div class="form-item__selection">
                  <input @change="validateSpecificAddress(billingAddress, errorBillingAddress, 'salutation')" v-model="billingAddress.salutation" type="radio" id="62388fb3a552f" name="" :value="t('checkout.woman')">
                  <label for="62388fb3a552f"> {{t('checkout.woman')}} </label>
                </div>
              </div>
              <span v-show="errorBillingAddress.salutation" data-v="" class="mandatorymessage">{{t('checkout.choose_salutation')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorBillingAddress.firstname ? 'error' : '']">
              <input @change="validateSpecificAddress(billingAddress, errorBillingAddress, 'firstname')" v-model="billingAddress.firstname" data-v=""  type="text" name="" :placeholder="t('checkout.firstname')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.firstname')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorBillingAddress.firstname" data-v="" class="mandatorymessage">{{t('checkout.choose_firstname')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorBillingAddress.lastname ? 'error' : '']">
              <input @change="validateSpecificAddress(billingAddress, errorBillingAddress, 'lastname')" v-model="billingAddress.lastname" data-v=""  type="text" name="" :placeholder="t('checkout.lastname')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.lastname')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorBillingAddress.lastname" data-v="" class="mandatorymessage">{{t('checkout.choose_lastname')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorBillingAddress.company ? 'error' : '']">
              <input v-model="billingAddress.company" data-v=""  type="text" name=""  :placeholder="t('checkout.company')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.company')}}</span>
              </label>

              <span data-v="" class="mandatorymessage" style="display: none;"></span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorBillingAddress.department ? 'error' : '']">
              <input v-model="billingAddress.department" data-v=""  type="text" name="" :placeholder="t('checkout.department')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.department')}}</span>
              </label>

              <span data-v="" class="mandatorymessage" style="display: none;"></span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorBillingAddress.street ? 'error' : '']">
              <input @change="validateSpecificAddress(billingAddress, errorBillingAddress, 'street')" v-model="billingAddress.street" data-v=""  type="text" name="" :placeholder="t('checkout.street')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.street')}} <span class="mandatory">*</span></span>
              </label>

              <span v-show="errorBillingAddress.street" data-v="" class="mandatorymessage">{{t('checkout.choose_street')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorBillingAddress.street_addition ? 'error' : '']">
              <input @change="validateSpecificAddress(billingAddress, errorBillingAddress, 'street_addition')" v-model="billingAddress.street_addition" data-v=""  type="text" name="" :placeholder="t('checkout.number')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.number')}} <span class="mandatory">*</span></span>
              </label>

              <span v-show="errorBillingAddress.street_addition" data-v="" class="mandatorymessage">{{t('checkout.choose_street')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorBillingAddress.zip ? 'error' : '']">
              <input @change="validateSpecificAddress(billingAddress, errorBillingAddress, 'zip')" v-model="billingAddress.zip" data-v=""  type="text" name="" :placeholder="t('checkout.zip')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.zip')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorBillingAddress.zip" data-v="" class="mandatorymessage">{{t('checkout.choose_zip')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorBillingAddress.city? 'error' : '']">
              <input @change="validateSpecificAddress(billingAddress, errorBillingAddress, 'city')" v-model="billingAddress.city" data-v=""  type="text" name="" :placeholder="t('checkout.city')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.city')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorBillingAddress.city" data-v="" class="mandatorymessage">{{t('checkout.choose_city')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50 dropdown position-relative" :class="[errorBillingAddress.country ? 'error' : '']">
              <div :class="billingAddress.country !== '' ? 'dropdown__selected--selected' : ''" class="dropdown__selected d-flex justify-content-end align-items-center">
                <label>
                  <span class="origin">{{countries[billingAddress.country]}} <span class="mandatory">*</span></span>
                </label>
              </div>
              <span v-show="errorBillingAddress.country" data-v="" class="mandatorymessage">{{t('checkout.choose_country')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50"></div>
            <div data-v="" class="form-item field-float col-50" :class="[errorBillingAddress.email ? 'error' : '']">
              <input @change="validateSpecificAddress(billingAddress, errorBillingAddress, 'email')" v-model="billingAddress.email" data-v=""  type="email" name="" :placeholder="t('checkout.email')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.email')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorBillingAddress.email" data-v="" class="mandatorymessage">{{t('checkout.choose_email')}}</span>
            </div>
            <div data-v="" class="form-item field-float col-50" :class="[errorBillingAddress.phone ? 'error' : '']">
              <input @change="validateSpecificAddress(billingAddress, errorBillingAddress, 'phone')" v-model="billingAddress.phone" data-v=""  type="text" name="" :placeholder="t('checkout.phone')">
              <label data-v="" for="">
                <span class="origin">{{t('checkout.phone')}} <span class="mandatory">*</span></span>
              </label>
              <span v-show="errorBillingAddress.phone" data-v="" class="mandatorymessage">{{t('checkout.choose_phone')}}</span>
            </div>
          </form>
          <a @click="checkStep1('second')" class="btn continue-button position-relative continue-button--first w-100 d-flex align-items-center justify-content-center" :class="['bg-secondary-'+theme,theme == 'white' ? 'text-'+theme : 'text-primary-'+theme]">
            <loading-element v-if="theme == 'dark'" class="continue-button__spinner" :z-index="2" :is-loading="isLoading" :bg-color="'#FDC300'" center absolute ></loading-element>
            <loading-element v-else :z-index="2" class="continue-button__spinner" :is-loading="isLoading" :bg-color="'#c80000'" center absolute ></loading-element>
            <p>{{t('checkout.continue')}}</p>
          </a>
        </div>
        <div v-show="activeStep != 'first' && step1finish == true" class="spareparts_checkoutsteps__inside__finish">
          <div class="row">
            <div class="col-6 col-sm-4 col-lg-3">
              <h3>{{t('checkout.delivery_address')}}</h3>
              <p>
                {{shippingAddress.firstname}} {{shippingAddress.lastname }}
              </p>
              <p>
                {{shippingAddress.street}} {{shippingAddress.street_addition}}
              </p>
              <p>
                {{shippingAddress.zip}} {{shippingAddress.city}}
              </p>
            </div>
            <div class="col-6 col-sm-4 col-lg-3">
              <h3>{{t('checkout.billing_address')}}</h3>
              <div v-if="diffrentaddress">
                <p>
                  {{billingAddress.firstname}} {{billingAddress.lastname}}
                </p>
                <p>
                  {{billingAddress.street}} {{billingAddress.street_addition}}
                </p>
                <p>
                  {{billingAddress.zip}} {{billingAddress.city}}
                </p>
              </div>
              <p v-else>{{t('checkout.is_like_shipping')}}</p>
            </div>
            <div class="d-none d-sm-flex col-2 col-lg-3"></div>
            <div class="d-none d-sm-flex col-2 col-lg-3"></div>
          </div>
        </div>
      </div>
    </div>
    <div :class="[theme == 'dark' ? 'bg-third-dark' : 'bg-fifth-white',activeStep == 'second' ? 'open' : '']" class="px-3 py-3 px-sm-4 py-sm-5 spareparts_checkoutsteps__two mt-2">
      <div @click="checkStep1('second')" class="spareparts_checkoutsteps__top pb-2 pb-sm-0 d-flex align-items-start align-items-sm-center justify-content-between">
        <div class="d-flex flex-column flex-sm-row"><p class="d-flex align-items-center justify-content-center mr-4">2</p><span class="d-flex align-items-center">{{t('checkout.shippingmethod')}}</span></div><a v-if="activeStep != 'second' && step2finish == true" @click="activeStep='second'" class="changeStep d-flex align-items-center justify-content-center">{{t('checkout.change')}}</a>
      </div>
      <div class="spareparts_checkoutsteps__inside pr-0 pr-lg-3">
        <div v-show="activeStep == 'second'" class="pb-2 pt-3 spareparts_checkoutsteps__inside__change">
          <form enctype="multipart/form-data" method="post" novalidate="novalidate" class="form form--floating-labels"><input type="hidden" name="path" value="checkout">
            <input type="hidden" name="id" value="623479722c086">
            <div class="form-item radio">
              <div class="d-flex py-2 justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="form-item__selection">
                    <input v-model="shippingMethod[0][0]" type="radio" id="62388fb3a752d" name="" value="1">
                    <label for="62388fb3a752d">
                      <div class="radio__chooser pl-0 p-lg-2">
                        <h3>{{t('checkout.default_delivery')}}</h3>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="d-none dhlIcon">

                </div>
              </div>
              <span v-show="shippingMethod[0][2]" data-v="" class="mandatorymessage mb-2">{{t('checkout.choose_delivery')}}</span>
            </div>
          </form>
          <a @click="checkStep2('third')" class="btn mt-2 position-relative continue-button w-100 d-flex align-items-center justify-content-center" :class="['bg-secondary-'+theme,theme == 'white' ? 'text-'+theme : 'text-primary-'+theme]">
            <loading-element v-if="theme == 'dark'" class="continue-button__spinner" :z-index="2" :is-loading="isLoading" :bg-color="'#FDC300'" center absolute ></loading-element>
            <loading-element v-else :z-index="2" class="continue-button__spinner" :is-loading="isLoading" :bg-color="'#c80000'" center absolute ></loading-element>
            <p>{{t('checkout.continue')}}</p>
          </a>
        </div>
        <div v-show="activeStep != 'second' && step2finish == true" class="pb-2 pt-3 spareparts_checkoutsteps__inside__finish">
          <div class="row">
            <div class="col-6 col-sm-4 col-lg-3">
              <div class="radio__chooser pl-0 p-lg-2">
                <h3>{{t('checkout.default_delivery')}}</h3>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-end justify-content-sm-start col-6 col-sm-4 col-lg-3">
              <div class="d-none dhlIcon">

              </div>
            </div>
            <div class="d-none d-sm-flex col-2 col-lg-3"></div>
            <div class="d-none d-sm-flex col-2 col-lg-3"></div>
          </div>
        </div>
      </div>
    </div>
    <div :class="[theme == 'dark' ? 'bg-third-dark' : 'bg-fifth-white',activeStep == 'third' ? 'open' : '']" class="px-3 py-3 px-sm-4 py-sm-5 spareparts_checkoutsteps__three mt-2">
      <div @click="checkStep2('third')" class="spareparts_checkoutsteps__top pb-2 pb-sm-0 d-flex align-items-start align-items-sm-center justify-content-between">
        <div class="d-flex flex-column flex-sm-row"><p class="d-flex align-items-center justify-content-center mr-4">3</p><span class="d-flex align-items-center">{{t('checkout.paymentmethod')}}</span></div><a v-if="activeStep != 'third' && step3finish == true" @click="activeStep='third'" class="changeStep d-flex align-items-center justify-content-center">{{t('checkout.change')}}</a>
      </div>
      <div class="spareparts_checkoutsteps__inside pr-0 pr-lg-3">
        <div v-show="activeStep == 'third'" class="pb-2 pt-3 spareparts_checkoutsteps__inside__change">
          <form enctype="multipart/form-data" method="post" novalidate="novalidate" class="form form--floating-labels"><input type="hidden" name="path" value="checkout">
            <input type="hidden" name="id" value="623479722c086">
            <div class="form-item radio">
              <div class="d-flex py-2 justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="form-item__selection">
                    <input v-model="payMethod[0][0]" type="radio" id="62288fb3a752d" name="" value="Visa">
                    <label @click="payMethod[0][3] = [t('checkout.creditcard'),'visaIcon']" for="62288fb3a752d">
                      <div class="radio__chooser pl-0 p-lg-2">
                        <h3>Visa</h3>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="visaIcon">

                </div>
              </div>
              <div class="d-flex py-2 justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="form-item__selection">
                    <input v-model="payMethod[0][0]" type="radio" id="62988fb3a752d" name="" value="Mastercard">
                    <label @click="payMethod[0][3] = [t('checkout.creditcard'),'masterIcon']" for="62988fb3a752d">
                      <div class="radio__chooser pl-0 p-lg-2">
                        <h3>Mastercard</h3>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="masterIcon">

                </div>
              </div>
              <div class="d-flex py-2 justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="form-item__selection">
                    <input v-model="payMethod[0][0]" type="radio" id="61188fb3a752d" name="" value="Paypal">
                    <label @click="payMethod[0][3] = ['Online','paypalIcon']" for="61188fb3a752d">
                      <div class="radio__chooser pl-0 p-lg-2">
                        <h3>Paypal</h3>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="paypalIcon">

                </div>
              </div>
              <span v-show="payMethod[0][2]" data-v="" class="mandatorymessage mb-2">{{t('checkout.choose_payment')}}.</span>
            </div>
          </form>
          <a @click="checkStep3('fourth')" class="btn mt-2 position-relative continue-button w-100 d-flex align-items-center justify-content-center" :class="['bg-secondary-'+theme,theme == 'white' ? 'text-'+theme : 'text-primary-'+theme]">
            <loading-element v-if="theme == 'dark'" class="continue-button__spinner" :z-index="2" :is-loading="isLoading" :bg-color="'#FDC300'" center absolute ></loading-element>
            <loading-element v-else :z-index="2" class="continue-button__spinner" :is-loading="isLoading" :bg-color="'#c80000'" center absolute ></loading-element>
            <p>{{t('checkout.continue')}}</p>
          </a>
        </div>
        <div v-show="activeStep != 'third' && step3finish == true" class="pb-2 pt-3 spareparts_checkoutsteps__inside__finish">
          <div class="row">
            <div class="col-6 col-sm-4 col-lg-3">
              <div class="radio__chooser pl-0 p-lg-2">
                <h3>{{payMethod[0][0]}}</h3>
                <p><span>{{payMethod[0][3][0]}}</span></p>
              </div>
            </div>
            <div class="d-flex justify-content-end align-items-center justify-content-sm-start col-6 col-sm-4 col-lg-3">
              <div :class="payMethod[0][3][1]">

              </div>
            </div>
            <div class="d-none d-sm-flex col-2 col-lg-3"></div>
            <div class="d-none d-sm-flex col-2 col-lg-3"></div>
          </div>
        </div>
      </div>
    </div>
    <div :class="[activeStep == 'fourth' ? 'open' : '']" class="px-4 py-4 spareparts_checkoutsteps__fourth mt-2">
      <div class="pr-0 pr-lg-3">
        <div :class="[aggreeterms == false ? '' : 'active']" class="d-flex billadresscheckmark d-flex align-items-center">
          <div @click="aggreeterms = !aggreeterms" class="checkmarkcontainer d-flex justify-content-center align-items-center">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 width="10px" height="10px" viewBox="0 0 78.369 78.369" style="enable-background:new 0 0 78.369 78.369;"
                 xml:space="preserve">
                    <g>
                        <path d="M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704
                            c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704
                            C78.477,17.894,78.477,18.586,78.049,19.015z"/>
                    </g>
                </svg>
          </div>
          <div class="pl-5 pt-3 agreeterms" v-html="agb_info">
          </div>
        </div>
        <div class="form-item">
          <span v-show="notAgree" data-v="" class="mandatorymessage mb-2">{{t('checkout.agb_error')}}</span>
          <div class="pt-3">
            <a @click="checkAgb" class="btn position-relative mt-5 continue-button w-100 d-flex align-items-center justify-content-center" :class="['bg-secondary-'+theme,theme == 'white' ? 'text-'+theme : 'text-primary-'+theme]">
              <loading-element v-if="theme == 'dark'" class="continue-button__spinner" :z-index="2" :is-loading="isLoading" :bg-color="'#FDC300'" center absolute ></loading-element>
              <loading-element v-else :z-index="2" class="continue-button__spinner" :is-loading="isLoading" :bg-color="'#c80000'" center absolute ></loading-element>
              <p>{{t('checkout.order_now')}}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoadingElement } from 'fire-vue-core';
import { FireI18n } from 'fire-js-i18n';
import {eventBus} from 'fire-vue-core';
import gql from "fake-tag";
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
export default {
  name: 'checkoutsteps',
  data: () => ({
    isLoading: false,
    svgcolor1: '',
    articlesLoaded: [],
    wholePrice: 1111,
    aggreeterms: 0,
    notAgree: false,
    activeStep: 'first',
    diffrentaddress: false,
    step1finish: false,
    step2finish: false,
    step3finish: false,
    step4finish: false,
    shippingMethod: [
      [1,true,false]
    ],
    payMethod: [
      [
        'Visa',true,false,['','visaIcon']
      ]
    ],
    billingAddress: {
      'salutation': '',
      'firstname': '',
      'lastname': '',
      'email': '',
      'company': '',
      'department': '',
      'street': '',
      'street_addition': '',
      'zip': '',
      'city': '',
      'country': '',
      'phone':''
    },
    shippingAddress: {
      'salutation': '',
      'firstname': '',
      'lastname': '',
      'email': '',
      'company': '',
      'department': '',
      'street': '',
      'street_addition': '',
      'zip': '',
      'city': '',
      'country': '',
      'phone':''
    },
    errorShippingAddress:
        {
          'salutation': false,
          'firstname': false,
          'lastname': false,
          'email': false,
          'street': false,
          'street_addition': false,
          'zip': false,
          'city': false,
          'country': false,
          'phone': false
        },
    errorBillingAddress:
        {
          'salutation': false,
          'firstname': false,
          'lastname': false,
          'email': false,
          'street': false,
          'street_addition': false,
          'zip': false,
          'city': false,
          'country': false,
          'phone': false
        },
    basketId: '',
    orderId:'',
    countries:{
      'CH': '',
      'AT': '',
      'DE': '',
      '':'',
      undefined:''
    },
  }),
  computed: {

  },
  components: {
    LoadingElement
  },
  directives: {

  },
  mixins: [

  ],
  props: {
    theme: String,
    country_selected: String,
    default_error: String,
    agb_info: String,
    delivery_cost: Number,
  },
  watch: {

  },
  created() {

  },
  destroyed() {

  },
  mounted () {
    this.setColors(this.theme);
    this.setCountry();
    this.payMethod = [
      [
        'Visa',true,false,[this.t('checkout.creditcard'),'visaIcon']
      ]
    ];
    this.articlesLoaded = this.articles;
    eventBus.$on('BasketIdLoaded', (id) =>
        {
          this.basketId = id
        }
    )
  },
  methods: {
    t(key, options) {
      return FireI18n.t(key, options);
    },
    setColors(theme) {
      if(theme == 'dark'){
        this.svgcolor1 = '#fff';
      }else if(theme == 'white'){
        this.svgcolor1 = '#000';
      }
    },
    setCountry()
    {
      this.countries['']= this.t('checkout.country');
      this.countries.undefined= this.t('checkout.country');
      this.countries.CH = this.t('checkout.countryCH');
      this.countries.AT = this.t('checkout.countryAT');
      this.countries.DE = this.t('checkout.countryDE');
      this.shippingAddress.country = this.country_selected;
      this.billingAddress.country = this.country_selected;
      this.shippingAddress.salutation = this.t('checkout.man');
      this.billingAddress.salutation = this.t('checkout.man');

    },
    checkStep1(step) {
      this.isLoading = true;
      let self = this;
      let finished = true;
      this.clearError(this.errorShippingAddress)
      finished = this.validateAddress(this.shippingAddress, this.errorShippingAddress)
      if(this.diffrentaddress == true)
      {
        this.clearError(this.errorBillingAddress)
        finished = this.validateAddress(this.billingAddress, this.errorBillingAddress)
      }
      this.step1finish = finished;
      if(this.step1finish == true){
        this.clearError(this.errorShippingAddress)
        this.clearError(this.errorBillingAddress)
        this.activeStep = step;
        console.log('activeStep:  ',this.activeStep);
      }else{
        this.activeStep = this.activeStep
      }
      this.isLoading = false;
    },
    checkStep2(step) {
      this.isLoading = true;
      let self = this;
      let finished = true;
      this.checkStep1('third');
      if(this.step1finish == true){
        this.shippingMethod.forEach(function(item, index){
          if(item[0] == '' && item[1] == true){
            finished = false;
            self.shippingMethod[index].splice(2, 1, true);
          }else{
            self.shippingMethod[index].splice(2, 1, false);
          }
        });

        this.step2finish = finished;
        if(this.step2finish == true && this.step1finish == true){
          this.activeStep = step;
        }else{
          this.activeStep = this.activeStep
        }
      }
      this.isLoading = false;
    },
    checkStep3(step) {
      this.isLoading = true;
      let self = this;
      let finished = true;
      this.payMethod.forEach(function(item, index){
        if(item[0] == '' && item[1] == true){
          finished = false;
          self.payMethod[index].splice(2, 1, true);
        }else{
          self.payMethod[index].splice(2, 1, false);
        }
      });

      this.step3finish = finished;
      if(this.step3finish == true){
        this.activeStep = step;
      }else{
        this.activeStep = this.activeStep
      }
      this.isLoading = false;
    },
    checkAgb()
    {
      if(this.aggreeterms)
      {
        this.submitBasket()
      }
      else {
        this.notAgree = true
      }
    },
    submitBasket()
    {
      this.isLoading = true;
      let orderData = {
        'basket_id': this.basketId,
      }

      let invoiceOrderAddress
      if (this.diffrentaddress)
      {
        invoiceOrderAddress = this.billingAddress;
      }
      else
      {
        invoiceOrderAddress = this.shippingAddress;
      }
      let deliveryOrderAddress = this.shippingAddress;;

      const body = {
        query: gql`
                        mutation submitBasket(
                                $orderData: OrderInputType!,
                                $invoiceOrderAddress: OrderAddressInputType!,
                                $deliveryOrderAddress: OrderAddressInputType!
                            ){
                            submitBasket (
                                    orderData: $orderData,
                                    invoiceOrderAddress: $invoiceOrderAddress,
                                    deliveryOrderAddress: $deliveryOrderAddress
                                ){
                                paymentTransactionId
                                errors
                                modelErrors {
                                    attribute
                                    className
                                    errors
                                }
                            }
                        }
                    `,
        variables: {
          'orderData': orderData,
          'invoiceOrderAddress': invoiceOrderAddress,
          'deliveryOrderAddress': deliveryOrderAddress,
        }
      };

      fetch(graphqlApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': yii.getCsrfToken()
        },
        body: JSON.stringify(body)
      })
          .then(res => res.json())
          .then(res =>
          {
            console.log(res)
            if(!res.data.submitBasket[0].errors)
            {
              this.orderId = res.data.submitBasket[0].paymentTransactionId
              console.dir(this.orderId)
              this.getPaymentUrlAndRedirect(this.orderId)
            }
            else if (res.data.submitBasket[0].modelErrors)
            {
              let msg = this.formatModelErrors(res.data.submitBasket[0].modelErrors, res.data.submitBasket[0].errors);
              eventBus.$emit('OpenPopup', msg);
              console.log('msg: ');
              console.log(msg);
            }
            else {
              eventBus.$emit('OpenPopup', this.default_error)
            }
            this.isLoading = false;
          });
    },
    getPaymentUrlAndRedirect(id)
    {
      const body = {
        "orderId": id
      }
      fetch(apiBaseUrl+'shop/submiturl', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': yii.getCsrfToken()
        },
        body: JSON.stringify(body)
      })
          .then(res => res.json())
          .then(res =>
          {
            if (res.errors==='false')
            {
              window.location.href=res.url;
            }
            else
            {
              eventBus.$emit('OpenPopup', this.default_error)
            }
          });
    },
    clearError(errorArray)
    {
      Object.keys(errorArray).forEach(key =>
      {
        errorArray[key] = false;
      })
    },
    validateSpecificAddress(addressObj, addressErrorObj, key)
    {
      if(addressObj[key] == '' && addressErrorObj.hasOwnProperty(key))
      {
        addressErrorObj[key] = true;
      }else{
        addressErrorObj[key] = false;
      }
      if(key == 'phone')
      {
        try
        {
          const phoneUtil = PhoneNumberUtil.getInstance();
          let number = phoneUtil.parseAndKeepRawInput(addressObj[key], 'ZZ');
          let e164Number = phoneUtil.format(number, PhoneNumberFormat.E164);
          if (!phoneUtil.isValidNumber(number))
          {
            addressErrorObj[key] = true;
          }else{
            addressErrorObj[key] = false;
          }
          addressObj.phone = e164Number;
        } catch(e)
        {
          console.log(e)
          addressErrorObj[key] = true;
        }
      }
      if(key == 'email')
      {
        const re = /[a-zA-Z0-9\._%+-]+@[a-zA-Z0-9\.-]+\.[a-zA-Z]{2,}/;
        if (!addressObj[key] || !re.test(addressObj[key])) {
          addressErrorObj[key] = true;
        }else{
          addressErrorObj[key] = false;
        }
      }
      if(key == 'zip')
      {
        if (addressObj['country'] == 'CH' || addressObj['country'] == 'AT')
        {
          const re = /^[1-9]\d{3}$/;
          if (!addressObj[key] || !re.test(addressObj[key])) {
            addressErrorObj[key] = true;
          }else{
            addressErrorObj[key] = false;
          }
        }
        else
        {
          const re = /^\d{5}$/;
          if (!addressObj[key] || !re.test(addressObj[key])) {
            addressErrorObj[key] = true;
          }else{
            addressErrorObj[key] = false;
          }
        }
      }
    },
    validateAddress(addressObj, addressErrorObj)
    {
      let valid = true;
      Object.keys(addressObj).forEach(key =>
      {
        if(addressObj[key] == '' && addressErrorObj.hasOwnProperty(key))
        {
          addressErrorObj[key] = true;
          valid = false;
        }
        if(key == 'phone')
        {
          try
          {
            const phoneUtil = PhoneNumberUtil.getInstance();
            let number = phoneUtil.parseAndKeepRawInput(addressObj[key], 'ZZ');
            let e164Number = phoneUtil.format(number, PhoneNumberFormat.E164);
            if (!phoneUtil.isValidNumber(number))
            {
              addressErrorObj[key] = true;
              valid = false;
            }
            addressObj.phone = e164Number;
          } catch(e)
          {
            console.log(e)
            addressErrorObj[key] = true;
            valid = false;
          }
        }
        if(key == 'email')
        {
          const re = /[a-zA-Z0-9\._%+-]+@[a-zA-Z0-9\.-]+\.[a-zA-Z]{2,}/;
          if (!addressObj[key] || !re.test(addressObj[key])) {
            addressErrorObj[key] = true;
            valid = false;
          }
        }
        if(key == 'zip')
        {
          if (addressObj['country'] == 'CH' || addressObj['country'] == 'AT')
          {
            const re = /^[1-9]\d{3}$/;
            if (!addressObj[key] || !re.test(addressObj[key])) {
              addressErrorObj[key] = true;
              valid = false;
            }
          }
          else
          {
            const re = /^\d{5}$/;
            if (!addressObj[key] || !re.test(addressObj[key])) {
              addressErrorObj[key] = true;
              valid = false;
            }
          }
        }
      })
      return valid;
    },
    formatModelErrors(errorObj, errorsStock){
      let msg = '';
      let nl =  '<br/ >';
      const prefix = 'Stock_prefix:';
      console.log(errorObj);

      Object.keys(errorObj).forEach(line => {
        console.log(line)
        console.log(errorObj[line])
        console.log(line.className)
        if(errorObj[line].className ==  'ShopOrderAddress_1')
        {
          msg += this.t('checkout.delivery_address') + ': ' + nl + errorObj[line].errors[0] + nl;
        }
        if(errorObj[line].className ==  'ShopOrderAddress_2')
        {
          msg +=this.t('checkout.billing_address') + ': ' + nl + errorObj[line].errors[0] + nl;
        }
      })
      console.log(errorsStock)
      const errors = errorsStock.find(item => item.indexOf(prefix) > -1)
      console.log(errors)
      if (errors)
      {
        msg = errors.replace(prefix, '')
      }
      if (!msg)
      {
        msg = this.default_error
      }
      return msg
    }
  }
};
</script>

<style lang="scss">
@import "frontend/styles/framework";
.spareparts_checkoutsteps {
  &__fourth{
    transition: all 0.3s;
    visibility: hidden;
    opacity: 0;
    display: none;
    &.open{
      visibility: visible;
      opacity: 1;
      display: block;
    }
  }
  &--white{
    .open{
      .spareparts_checkoutsteps{
        &__top{
          p{
            color: $secondary-white;
          }
        }
      }
    }
    .spareparts_checkoutsteps{
      &__top{
        p {
          background-color: $white;
          color: $black;
        }
        span {
          color: $black;
        }
        &:hover{
          p{
            color: $secondary-white;
          }
        }
      }
    }
    .changeStep{
      border: 1px solid $secondary-white;
      background-color: transparent;
      color: $secondary-white;
      transition: all 0.3s;
      &:hover{
        background-color: $secondary-white;
        color: $white;
      }
    }
    .billadresscheckmark{
      .checkmarkcontainer{
        border: 1px solid $secondary-white;
        background-color: $white;
        &:hover{
          ///background-color: $secondary-white;
          svg{
            path{
              //fill:$white;
            }
          }
        }
        svg{
          path{
            fill:#fff;
          }
        }
      }
      &.active{
        .checkmarkcontainer{
          background-color: $secondary-white;
          svg{
            path{
              fill:$white;
            }
          }
        }
        &:hover{
          .checkmarkcontainer {
            border: 1px solid $secondary-white;
            //background-color: $white;

            svg {
              path {
                //fill: $secondary-white;
              }
            }
          }
        }
      }
      .agreeterms{
        a{
          color: $secondary-white;
          transition: color 0.3s;
          &:hover{
            color: #9a000d !important;
          }
        }
      }
    }
  }
  &--dark{
    .open{
      .spareparts_checkoutsteps{
        &__top{
          p{
            background-color: $secondary-dark;
            color: $dark;
          }
        }
      }
    }
    .spareparts_checkoutsteps{
      &__top{
        p {
          background-color: $white;
          color: $black;
        }
        span {
          color: $white;
        }
        &:hover{
          p{
            background-color: $secondary-dark;
            color: $dark;
          }
        }
      }
    }
    .changeStep {
      border: 1px solid $secondary-dark;
      background-color: transparent;
      color: $secondary-dark;
      transition: all 0.3s;

      &:hover {
        background-color: $secondary-dark;
        color: $black;
      }
    }
    .billadresscheckmark{
      .checkmarkcontainer{
        border: 1px solid $secondary-dark;
        background-color: $white;
        svg{
          path{
            fill: $white;
          }
        }
      }
      &:hover{
        .checkmarkcontainer{
          //background-color: $secondary-dark;
          svg{
            path{
              //fill: $black;
            }
          }
        }
      }
      &.active{
        .checkmarkcontainer{
          background-color: $secondary-dark;
          svg{
            path{
              fill: $black;
            }
          }
        }
        &:hover{
          .checkmarkcontainer {
            border: 1px solid $secondary-dark;
            //background-color: $white;

            svg {
              path {
                //fill: $white;
              }
            }
          }
        }
      }
      .agreeterms{
        a{
          color: $secondary-dark;
          transition: color 0.3s;
          &:hover{
            color: #ca9c00 !important;
          }
        }
      }
    }
  }
  &__top{
    cursor: pointer;
    p{
      transition: all 0.3s;
      border-radius: 50%;
      width: 35px;
      height: 35px;
      font-size: 0.85rem;
    }
    span{
      font-size: 1.2rem;
      font-weight: 500;
    }
  }
  .changeStep{
    height: 40px;
    font-size: 0.85rem;
    font-weight: 300;
    padding-left: 35px;
    padding-right: 35px;
  }
  .billingaddress {
    transition: all 0.3s;
    height: 0px;
    visibility: hidden;
    opacity: 0;
    > div{
      display: none;
    }
    &.open{
      height: auto;
      visibility: visible;
      opacity: 1;
      > div{
        display: block;
      }
    }
  }
  .billadresscheckmark{
    .checkmarkcontainer{
      cursor: pointer;
      transition: all 0.3s;
      min-width: 22px;
      min-height: 22px;
      svg{
        path{
          transition: all 0.3s;
        }
      }
    }
    p{
      font-size: 0.75rem;
      font-weight: 300;
      &.agreeterms{
        font-size: 0.85rem;
      }
    }
  }
  .continue-button{
    &__spinner{
      .spinner-border{
        color: $white !important;
        border: 5px solid currentColor;
        border-right-color: transparent;
      }
    }
    height: 50px;
    cursor: pointer;
    p{
      font-size: 0.8rem;
    }
  }
  &__inside{
    padding-left: 0px;
    .postfinanceIcon{
      background-image: url("/assets/sparepartcheckout/images/Schweizerische_Post_Logo.svg");
      background-position: center center;
      background-color: transparent;
      background-size: contain;
      background-repeat: no-repeat;
      width: 70px;
      height: 40px;
    }
    .dhlIcon{
      background-image: url("/assets/sparepartcheckout/images/dhllogo.svg");
      background-position: center center;
      background-color: transparent;
      background-size: contain;
      background-repeat: no-repeat;
      width: 90px;
      height: 40px;
    }
    .visaIcon{
      background-image: url("/assets/sparepartcheckout/images/visa.svg");
      background-position: center center;
      background-color: white;
      border-radius: 6px;
      width: 70px;
      height: 40px;
    }
    .masterIcon{
      background-image: url("/assets/sparepartcheckout/images/mastercard.svg");
      background-position: center center;
      background-color: white;
      border-radius: 6px;
      width: 70px;
      height: 40px;
    }
    .paypalIcon{
      background-image: url("/assets/sparepartcheckout/images/paypal.svg");
      background-position: center center;
      background-color: white;
      border-radius: 6px;
      width: 70px;
      height: 40px;
    }
    &__finish{
      h3{
        font-size: 0.85rem;
      }
      p{
        font-size: 0.75rem;
        font-weight: 300;
        span{
          font-size: 0.65rem;
        }
      }
    }
    &__change{
      .radio__chooser{
        h3{
          font-size: 0.85rem;
        }
        p{
          font-size: 0.75rem;
          font-weight: 300;
          span{
            font-size: 0.65rem;
          }
        }
      }

    }
  }
  @media (min-width: 992px) {
    .spareparts_checkoutsteps{
      &__inside{
        padding-left: 56px;
      }
    }
    .billadresscheckmark{
      p{
        &.agreeterms{
          font-size: 0.85rem;
          width: 80%;
        }
      }
    }
  }
}

</style>